import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";
import { GoogleMap, Polygon, Marker, InfoWindow } from "@react-google-maps/api";
import { fetch_test_departments } from "../../endpoints/API";

const containerStyle = {
    width: "100%",
    height: "500px",
};

const AllLabViewPolygonMap = ({ isOpen, onClose, labs, highlightCoords }) => {

    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);

    useEffect(() => {
        const loadDepartments = async () => {
            const res = await fetch_test_departments();
            setDepartments(res.data);

            const pathology = res.data.find(d => d.name === "pathology");
            if (pathology) {
                setSelectedDepartment(pathology.id);
            }
        };

        if (isOpen) {
            loadDepartments();
        }
    }, [isOpen]);
    if (!labs?.length) return null;

    const filteredLabs = labs
        .map(lab => {
            const territory = lab.territories?.find(
                t => t.test_department?.id === selectedDepartment
            );

            return territory
                ? {
                    name: lab.name,
                    coordinates: territory.coordinates,
                }
                : null;
        })
        .filter(Boolean);

    // Center map on first lab or highlighted polygon
    const defaultCenter =
        filteredLabs?.length
            ? { lat: filteredLabs[0].coordinates[0][1], lng: filteredLabs[0].coordinates[0][0] }
            : { lat: 20.5937, lng: 78.9629 }; // fallback India center



    return (
        <Modal
            title="All Labs Service Areas"
            open={isOpen}
            onCancel={onClose}
            footer={null}
            width={1200}
        >
            {/* Top Control Bar */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "16px",
                    padding: "12px 16px",
                    background: "#fafafa",
                    borderRadius: "8px",
                    border: "1px solid #f0f0f0",
                }}
            >
                <div style={{ fontWeight: 600, fontSize: "14px" }}>
                    Filter by Department
                </div>

                <Select
                    style={{ width: 250 }}
                    placeholder="Select Department"
                    value={selectedDepartment}
                    onChange={(value) => setSelectedDepartment(value)}
                >
                    {departments.map((dept) => (
                        <Select.Option key={dept.id} value={dept.id}>
                            {dept.name.toUpperCase()}
                        </Select.Option>
                    ))}
                </Select>
            </div>

            {/* Google Map */}
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={defaultCenter}
                zoom={11}
            >
                {filteredLabs.map((lab, i) => {
                    const path = lab.coordinates.map((c) => ({
                        lat: c[1],
                        lng: c[0],
                    }));

                    const isHighlighted =
                        JSON.stringify(lab.coordinates) ===
                        JSON.stringify(highlightCoords);

                    return (
                        <React.Fragment key={i}>
                            <Polygon
                                path={path}
                                options={{
                                    fillColor: isHighlighted
                                        ? "rgba(255, 0, 0, 0.4)"
                                        : "rgba(63, 81, 181, 0.3)",
                                    strokeColor: isHighlighted ? "#ff0000" : "#3f51b5",
                                    strokeWeight: isHighlighted ? 3 : 2,
                                }}
                            />
                            <Marker
                                position={path[0]}
                                label={{
                                    text: lab.name,
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                }}
                            />
                        </React.Fragment>
                    );
                })}
            </GoogleMap>
        </Modal>
    );
};

export default AllLabViewPolygonMap;
